import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-weedfree-client-documents',
  templateUrl: './weedfree-client-documents.component.html',
  styleUrls: ['./weedfree-client-documents.component.scss']
})
export class WeedfreeClientDocumentsComponent implements OnInit {

  public clients: KeyValue<number, string>;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.clients = data.clients;
    });
  }

  onClientChange(client: number) {
    this.router.navigate(["/weedfree", "client-documents", client]);
  }

}
